import { useState, useEffect, useCallback, useMemo } from 'react';
import { Options } from '@lib/Requests/types';
import { BehaviorCategoryProps } from '../../Types/BehaviorCategoryProps';
import { useBehaviorCategory } from '../behavior/behavior.category.hook';

const useBehaviorCategoryOptions = () => {
    const { data } = useBehaviorCategory();
  
    const options = useMemo(() => {
      if (data) {
        return data.map((item: BehaviorCategoryProps) => ({
          Name: item.name,
          value: item.id,
          Enabled: 1,
        }));
      }
      return [];
    }, [data]); 
  
    return options;
  };
  
export default useBehaviorCategoryOptions;
